import Component from '@glimmer/component';

interface SocialIconsSignature {
  Args: {
    class?: string;
    iconClass?: string;
  };
}

const socialLinks = [
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/madow.tech/',
    icon: 'svg-instagram',
    label: 'Follow us on Instagram'
  },
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/company/madow-tech',
    icon: 'svg-linkedin',
    label: 'Follow us on LinkedIn'
  },
  {
    name: 'X',
    url: 'https://x.com/madowtech',
    icon: 'svg-x',
    label: 'Follow us on X'
  },
  {
    name: 'Bluesky',
    url: 'https://bsky.app/profile/madow-tech.bsky.social',
    icon: 'svg-bluesky',
    label: 'Follow us on Bluesky'
  }
];

export default class SocialIcons extends Component<SocialIconsSignature> {
  get containerClass() {
    return this.args.class || 'flex gap-4';
  }

  get iconClass() {
    return this.args.iconClass || 'h-5 w-5';
  }

  get socialLinks() {
    return socialLinks;
  }

  <template>
    <div class={{this.containerClass}}>
      {{#each this.socialLinks as |social|}}
        <a
          href={{social.url}}
          class="hover:scale-105 transition-transform hover:[filter:drop-shadow(0_0_4px_rgba(255,255,255,0.5))]"
          target="_blank"
          rel="noopener noreferrer"
          aria-label={{social.label}}
        >
          <img
            src="/icons/{{social.icon}}.svg"
            class={{this.iconClass}}
            alt="Icono de {{social.name}}"
          />
        </a>
      {{/each}}
    </div>
  </template>
}
